import React, { useContext, useEffect, useState } from 'react';
import SelectSubAccountDropdown from '../global-components/selectSubAccountDropdown';
import DateRangePicker from '../global-components/litePicker';
import { formatDateWithDashes } from '../../utils/helper';
import { fetchSearchShipments } from '../../api/admin';
import { mapShipmentStatusBtn } from '../../utils/utils';
import { useLocation, useNavigate } from 'react-router-dom';
import { AbilityContext } from '../../context/AbilityContext';
import { RootState } from '../../redux/rootReducer';
import { useSelector } from 'react-redux';
import calendarIcon from '../../assets/icons/new_icon/calendar.svg';

function SearchShipmentsContainer() {
  const location = useLocation();
  const navigate = useNavigate();
  const ability = useContext(AbilityContext);
  const { userData } = useSelector((state: RootState) => state.mainAppData);
  const isVendor = userData?.is_vendor;
  const isAdmin = ability.can('read', 'Admin Shipments');
  const search = new URLSearchParams(location.search).get('search');
  const [selectedAccount, setSelectedAccount] = useState('');
  const [searchText, setSearchText] = useState(search || '');
  const [shipmentData, setShipmentData] = useState<any>();
  const [selectedDates, setSelectedDates] = useState<{
    startDate: Date | null;
    endDate: Date | null;
  }>({
    startDate: new Date(Date.now() - 90 * 24 * 60 * 60 * 1000),
    endDate: new Date(Date.now() + 1 * 24 * 60 * 60 * 1000),
  });

  const handleDateChange = (startDate: Date, endDate: Date) => {
    setSelectedDates({ startDate, endDate });
  };
  function searchHandle() {
    let payload = {
      search: searchText,
      start_date: selectedDates.startDate
        ? formatDateWithDashes(selectedDates.startDate)
        : '',
      end_date: selectedDates.endDate
        ? formatDateWithDashes(selectedDates.endDate)
        : '',
      account: selectedAccount,
    };
    fetchSearchShipments(payload, isAdmin)
      .then((response) => {
        if (!response?.data?.is_error) {
          setShipmentData(response.data.content);
        }
      })
      .catch((e) => {});
  }

  function handleSubmit(event: any) {
    event.preventDefault();
    searchHandle(); // Call your search function
  }
  useEffect(() => {
    searchHandle();
  }, [search]);
  return (
    <div
      className='container-fluid my-4 px-4'
      style={{ minHeight: 300 }}
    >
      <div className='row'>
        <div className='col-sm-12 my-auto'>
          <h1 className='fw-bold fs-4 boldStepperText'>Search Results</h1>
        </div>
      </div>
      <div
        className='w-100 d-flex gap-3 mt-4'
        onSubmit={handleSubmit}
      >
        <div className='w-100'>
          <label
            htmlFor='date_range'
            className='lex-18-400'
          >
            Date Range
          </label>
          <br />
          <DateRangePicker
            id={'date_range_picker'}
            className={'form-control ubbe-input mt-1'}
            selectedDates={selectedDates}
            onChange={handleDateChange}
            calendarIcon={calendarIcon}
          />
        </div>
        {!isVendor && (
          <div className='w-100'>
            <SelectSubAccountDropdown
              setSelectedSubAccount={setSelectedAccount}
              selectedSubAccount={selectedAccount}
              label='Accounts'
            />
          </div>
        )}
        <div className='w-100'>
          <label
            // data-tooltip-id='my-tooltip'
            // data-tooltip-content={selectedOption ? selectedOption : placeholder}
            className='dropdown-label'
          >
            {'Shipment ID'}
          </label>
          <div style={{ minWidth: '331px' }}>
            <div className='input-group'>
              <div className='relative w-100'>
                <input
                  className='form-control ubbe-input w-100'
                  id='search_page'
                  placeholder='Search'
                  value={searchText}
                  onChange={(e) => {
                    setSearchText(e.target.value);
                  }}
                />
              </div>
              <div className='search-icon'>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='16'
                  height='16'
                  viewBox='0 0 16 16'
                  fill='none'
                >
                  <path
                    d='M6.84236 13.684C8.06403 13.6837 9.25737 13.3546 10.3 12.7387C10.7351 12.4817 11.2993 12.5089 11.6566 12.8662L14.186 15.3954C14.5199 15.7293 15.0613 15.7293 15.3953 15.3954C15.7292 15.0614 15.7292 14.5199 15.3953 14.186L12.8662 11.657C12.5088 11.2997 12.4817 10.7353 12.7389 10.3002C13.3551 9.25743 13.6844 8.06389 13.6847 6.84199C13.6847 3.06949 10.6151 0 6.84236 0C3.06965 0 0 3.06949 0 6.84199C0 10.6145 3.06965 13.684 6.84236 13.684ZM6.84236 1.7105C9.67253 1.7105 11.9741 4.01197 11.9741 6.84199C11.9741 9.67201 9.67253 11.9735 6.84236 11.9735C4.01219 11.9735 1.71059 9.67201 1.71059 6.84199C1.71059 4.01197 4.01219 1.7105 6.84236 1.7105Z'
                    fill='#808080'
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
        <div className='w-100'>
          <div
            className=''
            style={{ marginTop: '28px' }}
          >
            <button
              type='button'
              className={
                'active-filter mt-auto '
                // : 'mt-auto  disable-filter '
              }
              style={{ width: '154px' }}
              onClick={handleSubmit}
              // disabled={!handleToggleChange} // Disable button if no dropdown is selected
            >
              Search
            </button>
          </div>
          {/* <button
            type='submit'
            className='btn btn-ubbe w-100'
          >
            Search
          </button> */}
        </div>
      </div>
      <div className='row'>
        <div
          className='col-12'
          id='results'
        >
          {shipmentData && shipmentData.length > 0 ? (
            shipmentData.map((item: any) => (
              <>
                <div className='ubbe-card mt-4 report'>
                  <div className='card-body reports-border-left-card'>
                    <div className='d-flex flex-column flex-lg-row justify-content-lg-between align-items-lg-center gap-2'>
                      <div className='d-flex flex-column'>
                        <h3
                          className='mb-1 h4 lex-20-500'
                          id='report_title'
                        >
                          {formatDateWithDashes(new Date(item?.ship_date))} -{' '}
                          {item?.leg_id} - {item?.carrier}
                        </h3>
                        <p className='card-text mt-3 lex-14-300'>
                          {`${item?.origin?.city} ${item?.origin?.province}, ${item?.origin?.country} to ${item?.destination?.city} ${item?.destination?.province}, ${item?.destination?.country} | ${item?.ff_number} ${item?.reference_one} ${item?.reference_two} ${item?.tracking_identifier} ${item?.carrier_pickup_identifier} ${item?.carrier_api_id} ${item?.project} ${item?.booking_number}`}
                        </p>
                      </div>
                      <div className='d-flex gap-3'>
                        <div className=' my-auto text-end'>
                          {mapShipmentStatusBtn(
                            item.is_shipped,
                            item.is_delivered,
                            item.is_cancel,
                            item.is_cancel_completed,
                            'p-3',
                          )}
                        </div>
                        <div className='my-auto text-end'>
                          {ability.can('read', 'Shipment View') && (
                            <p
                              className='btn-ubbe-no-style mb-0'
                              onClick={() => {
                                navigate(
                                  isAdmin
                                    ? `/app/admin/shipment-history/view?shipment_id=${item?.shipment_id}`
                                    : `/app/shipment-history/view?shipment_id=${item?.shipment_id}`,
                                );
                              }}
                            >
                              <u
                                className='labelText'
                                style={{
                                  color: '#251163',
                                  fontSize: '16px',
                                  cursor: 'pointer',
                                }}
                              >
                                {' '}
                                Details
                              </u>
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ))
          ) : (
            <div className='ubbe-card mt-4'>
              <div className='card-body p-4 text-center'>
                <span className='my-auto'>
                  Sorry, no results found for search and filter parameters
                  above.
                </span>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default SearchShipmentsContainer;
